import { OdooContext } from "OdooProvider";
import { useContext } from "react";

const PaymentsView = ({ data, currencySymbol }) => {
  const { odooUrl } = useContext(OdooContext);

  return (
    <div className="-mx-2 text-sm">
      <table className="font-code whitespace-nowrap">
        <thead>
          <tr>
            <th>Due Date</th>
            <th>Name</th>
            <th className="w-full">Partner</th>
            <th className="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((i, index) => (
            <tr key={index} className="border-y dark:border-gray-700">
              <td>{i.date}</td>
              <td>
                <a
                  href={`${odooUrl}/odoo/action-176/${i.id}`}
                  rel="noreferer"
                  target="_blank"
                >
                  {i.name}
                </a>
              </td>
              <td>{i.partner_id[1]}</td>
              <td className="text-right">
                <div className="text-xs opacity-70">
                  {i.currency}{" "}
                  {i.amount_in_currency.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
                <div>
                  {i.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  {currencySymbol}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsView;
